/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import sha1 from 'js-sha1'

import cleanString from './clean-string'

export const getWordHash = (word: string, language: string) => {
  const cleanedWord = cleanString(word) as string
  // @ts-ignore
  const wordHash = sha1(`${language}-${cleanedWord}`)

  return wordHash as string
}
